import type { IconData } from '@stacksjs/iconify-core'

export const compassNavigatorSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M41.615 1.272a4.364 4.364 0 0 1 5.13 5.111c-.756 4.04-2.061 10.457-3.717 16.412c-.827 2.976-1.75 5.867-2.748 8.3c-.977 2.385-2.096 4.512-3.384 5.8s-3.415 2.407-5.8 3.385c-2.434.997-5.325 1.92-8.3 2.748c-5.956 1.656-12.373 2.96-16.413 3.717a4.364 4.364 0 0 1-5.11-5.13c.774-4.053 2.105-10.5 3.767-16.465c.83-2.98 1.752-5.872 2.738-8.297c.965-2.371 2.066-4.487 3.327-5.749s3.378-2.362 5.75-3.327c2.424-.987 5.315-1.908 8.296-2.738c5.965-1.662 12.412-2.992 16.464-3.767M17 24a7 7 0 1 1 14 0a7 7 0 0 1-14 0\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default compassNavigatorSolid
